module.exports = __webpack_public_path__ + "assets/img/0218.ada6df28.svg";